module.exports = __webpack_public_path__ + "img/strategic-5.05762a62.png";